'use client';

import React, { Suspense } from 'react';
import WorkerLoginForm from '../WorkerLoginForm';

export default function MeistraiLoginPage() {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen bg-[#f0f4f8] flex items-center justify-center">
          <div className="w-8 h-8 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin" />
        </div>
      }
    >
      <WorkerLoginForm />
    </Suspense>
  );
}
